function isDecimal(value: string): boolean {
  const regex = /^-?(\d*[.,]?\d{0,4}|\d+)$/g;

  return regex.test(value);
}

function convertToNumber(value: string | undefined | number | null): number {
  if (value === undefined || value === null) return 0;

  if (typeof value === "string") {
    value = value?.replace(",", ".");
    const result = value === undefined ? 0 : Number(value);
    return result;
  }

  if (typeof value === "number") {
    if (isNaN(value)) return 0;
    if (value === Infinity) return 0;

    return value;
  }

  return 0;
}

function formatToString(value: string | undefined | number | null): string {
  const MINIMUM_DIGITS = 0;
  const MAXIMUM_DIGITS = 4;

  if (value === undefined || value === null) return "";

  if (typeof value === "number") {
    const formattedValue = value.toLocaleString("pt-BR", {
      minimumFractionDigits: MINIMUM_DIGITS,
      maximumFractionDigits: MAXIMUM_DIGITS,
    });
    return formattedValue.replace(/\./g, "");
  } else {
    const valueNumber = convertToNumber(value);
    const formattedValue = valueNumber.toLocaleString("pt-BR", {
      minimumFractionDigits: MINIMUM_DIGITS,
      maximumFractionDigits: MAXIMUM_DIGITS,
    });
    return formattedValue.replace(/\./g, "");
  }
}

function formatToBrazilianNumber(
  value: string | undefined | number | null
): string {
  const MINIMUM_DIGITS = 4;

  if (typeof value === "number") {
    return value.toLocaleString("pt-BR", {
      minimumFractionDigits: MINIMUM_DIGITS,
      maximumFractionDigits: MINIMUM_DIGITS,
    });
  } else {
    const valueNumber = convertToNumber(value);
    return valueNumber.toLocaleString("pt-BR", {
      minimumFractionDigits: MINIMUM_DIGITS,
      maximumFractionDigits: MINIMUM_DIGITS,
    });
  }
}

function formatToReaisBrazilianNumber(
  value: string | undefined | number | null
): string {
  const MINIMUM_DIGITS = 2;

  if (typeof value === "number") {
    return value.toLocaleString("pt-BR", {
      minimumFractionDigits: MINIMUM_DIGITS,
      maximumFractionDigits: MINIMUM_DIGITS,
    });
  } else {
    const valueNumber = convertToNumber(value);
    return valueNumber.toLocaleString("pt-BR", {
      minimumFractionDigits: MINIMUM_DIGITS,
      maximumFractionDigits: MINIMUM_DIGITS,
    });
  }
}
function addZeroToLeft(value: number | undefined): string {
  if (value === undefined) return "";

  const length = value.toString().length;

  switch (length) {
    case 1:
      return `00${value}`;
    case 2:
      return `0${value}`;
    case 3:
      return `${value}`;
    default:
      return `${value}`;
  }
}

function formatNumberDecimalPlace(value: number | null | undefined): string {
  if (value === null || value === undefined) return "0";

  return value.toLocaleString("pt-BR"); // separa milhar com ponto
}

function convertBrazilianRealStringToNumber(
  value: string | undefined | null
): number {
  if (!value) return 0;

  const cleaned = value
    .replace(/\s/g, "")
    .replace("R$", "")
    .replace(/\./g, "")
    .replace(",", ".");

  const result = Number(cleaned);
  return isNaN(result) ? 0 : result;
}

function convertPercentageStringToNumber(
  value: string | undefined | null
): number {
  if (!value) return 0;

  const cleaned = value.replace(/\s/g, "").replace("%", "").replace(",", ".");

  const result = Number(cleaned);
  return isNaN(result) ? 0 : result;
}

function formatCurrency(value: number): string {
  return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export { formatCurrency };

export const numberUtils = {
  isDecimal,
  convertToNumber,
  formatToBrazilianNumber,
  formatToReaisBrazilianNumber,
  formatToString,
  addZeroToLeft,
  formatNumberDecimalPlace,
  convertBrazilianRealStringToNumber,
  convertPercentageStringToNumber,
  formatCurrency,
};
